import { TranslateService } from '@ngx-translate/core';

export let APP_TRANSLATE!: TranslateService;

export function setTranslateService(service: TranslateService) {
  if (!APP_TRANSLATE) {
    APP_TRANSLATE = service;
  }
}
